import { render, staticRenderFns } from "./pxfz.vue?vue&type=template&id=706e1e69&scoped=true"
import script from "./pxfz.vue?vue&type=script&lang=js"
export * from "./pxfz.vue?vue&type=script&lang=js"
import style0 from "./pxfz.vue?vue&type=style&index=0&id=706e1e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e1e69",
  null
  
)

export default component.exports